"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StoryIcon = void 0;
const core_1 = require("@material-ui/core");
const React = require("react");
exports.StoryIcon = () => {
    return React.createElement(core_1.SvgIcon, { style: { fontSize: 48 }, viewBox: "0 0 48 48" },
        React.createElement("svg", { width: "48", height: "48", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React.createElement("path", { d: "M6 17.3H5.71005L5.50503 17.5051L2.7 20.3101V4.00003C2.7 3.28663 3.2866 2.70003 4 2.70003H20C20.7134 2.70003 21.3 3.28663 21.3 4.00003V16C21.3 16.7134 20.7134 17.3 20 17.3H6Z", stroke: "#C2CFE0", strokeWidth: "1.4" })));
};
